import { z } from 'zod';
import { orderDestinationTimeSchema, orderTimeSchema } from './order.destination.model';
import { dateSchema, integerSchema } from '../../validation';

//* time
export const orderAnalyticsTimeSchema = orderDestinationTimeSchema.extend({
  /** the time in minutes it took to assign a driver to order */
  timeToAssignDriver: orderTimeSchema,
});
export type OrderAnalyticsTime = z.infer<typeof orderAnalyticsTimeSchema>;

//* driver
export const orderAnalyticsDriverSchema = z.object({});
export type OrderAnalyticsDriver = z.infer<typeof orderAnalyticsDriverSchema>;

//* destination
export const orderAnalyticsDestinationSchema = z.object({
  allDestinationsAreInSameCity: z.boolean(),
});
export type OrderAnalyticsDestination = z.infer<typeof orderAnalyticsDestinationSchema>;

//* amount
export const orderAnalyticsPaymentSchema = z.object({
  isMultiCurrency: z.boolean(),
  /** the number of `days` delayed on payment.
   *
   * for example, if the payment term is to pay on 1st o the month, received it on 2nd,
   *
   * then, the `delayOnPaymentDueDate` will be 1
   */
  delayOnPaymentDueDate: integerSchema.default(0),
  /**
   * the expected date in which the customer will make the payment for this order.
   *
   * This would be based on the agreed payment terms, and historical data.
   */
  expectedPaymentDate: dateSchema,
});
export type OrderAnalyticsPayment = z.infer<typeof orderAnalyticsPaymentSchema>;

//* analytics
export const orderAnalyticsSchema = z.object({
  /** time matrix for the overall order */
  time: orderAnalyticsTimeSchema,

  destination: orderAnalyticsDestinationSchema,
  payment: orderAnalyticsPaymentSchema,
  driver: orderAnalyticsDriverSchema.optional(),
});
export type OrderAnalytics = z.infer<typeof orderAnalyticsSchema>;
